import { render, staticRenderFns } from "./AscHistogramChart.vue?vue&type=template&id=4c9687a5&scoped=true&"
import script from "./AscHistogramChart.vue?vue&type=script&lang=js&"
export * from "./AscHistogramChart.vue?vue&type=script&lang=js&"
import style0 from "./AscHistogramChart.vue?vue&type=style&index=0&id=4c9687a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9687a5",
  null
  
)

export default component.exports